<template>
<DIV>
  <span v-if="value.invoice_kind === 'outgoing'">[V]</span>
<span v-if="value.invoice_kind === 'incoming'">[S]</span>

<strong>{{ value.invoice_number }}</strong>
<UcInvoiceTypeBadge :value="value.invoice_type" :kind="value.invoice_kind" :advance="value.is_advance"></UcInvoiceTypeBadge>
<ItpBadge v-if="value.no_payment_required" variant="warning" class="m-0" :title="globs.noPaymentRequired">
  <iconify-icon icon="streamline:bill-cashless"></iconify-icon>
</ItpBadge>

</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceBadge extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcInvoiceBadge", UcInvoiceBadge);

</script>